import { render, staticRenderFns } from "./PendingClosureModal.vue?vue&type=template&id=0e85cdfa&scoped=true&"
import script from "./PendingClosureModal.vue?vue&type=script&lang=ts&"
export * from "./PendingClosureModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e85cdfa",
  null
  
)

export default component.exports